import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import excelenteAvatar from "../../assets/bg/excelente-avatar.png";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

function Scenario4Fin({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const videoRef = useRef(null);

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0 bgCircleBlue">
            <div className="row h-100 m-0">
            <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                <div className="content-overlay d-flex flex-column justify-content-start align-items-center h-75 px-5 position-relative pt-5">
                <img
                    src={oncommit}
                    alt="decorativo"
                    style={{ maxWidth: "187px", top: "18px", left: "20px" }}
                    className="position-absolute"
                />
                <img
                    src={excelenteAvatar}
                    alt="decorativo"
                    className="mb-5 mt-5"
                    style={{ maxWidth: "700px" }}
                />
                <div className="black txt26 w-50 text-center">
                    <p>
                    Excelente, han avanzado a la siguiente sala
                    </p>
                </div>
                <div className="mt-3 d-flex align-items-center w-100 justify-content-end">
                    <NextButton
                    navigateTo={ROUTES.TRANSITION_SCENARIOS}
                    activeScenario={5}
                    color="blue"
                    />
                </div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario4Fin);
